export enum UserRoles {
  POI_WRITE = 'POI_WRITE',
  POI_READ = 'POI_READ',
  IMAGE_WRITE = 'IMAGE_WRITE',
  IMAGE_READ = 'IMAGE_READ',
  USER_WRITE = 'USER_WRITE',
  ADMIN = 'ADMIN'
}
